<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col
        v-for="(sirene, index) in sirenen"
        :key="index"
        cols="12"
        xs="12"
        sm="6"
        md="4"
        lg="3"
        xl="2"
        @click="(selected === sirene) ? selected = null : selected = sirene"
        @mouseenter="hovered = sirene"
        @mouseleave="hovered = null"
      >
        <Sirene
          :sirene="sirene"
          :selected="selected === sirene"
          :hovered="hovered === sirene"
        ></Sirene>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Sirene from "../components/sirenen/Sirene";
export default {
  name: "SirenenView",
  components: { Sirene },
  data: () => ({
    show: false,
    selected: null,
    hovered: null,

    timer: null
  }),
  computed: {
    sirenen(){
      let searchQuery = this.$store.state.general.global_search.toLowerCase()
      let sirenen = this.$store.state.sirenen.sirenen
      return Object.fromEntries(
        Object.entries(sirenen).filter(([, value]) => value.address.toLowerCase().includes(searchQuery)
          || value.name_safus.toLowerCase().includes(searchQuery)
          || value.phonenumber.toLowerCase().includes(searchQuery)
        )
      );
    }
  },
  mounted() {
    this.$store.dispatch("update", { "context": "/sirenen" })
    setInterval(() => {
      if(!this.$store.getters.inPrivateNet){
        this.$store.dispatch("update", { "context": "/sirenen" })
      }
    }, 8000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};

</script>

<style scoped>

</style>
